import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import { Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterModule } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { Icon, ModalService, SLIDE_Y } from "@malirang/front-share";
import { CenterRoleBadgeComponent } from "../../../../components/center/role-badge/center-role-badge.component";
import { NotificationStore } from "../../../../stores/notification.store";
import { UserStore } from "../../../../stores/user.store";
import { SelectCenterComponent } from "../select-center/select-center.component";
import { SideMenuComponent } from "../side-menu/side-menu.component";
@Component({
    selector: "app-header",
    standalone: true,
    imports: [
        CommonModule,
        CdkMenuModule,
        RouterModule,
        Icon,
        SelectCenterComponent,
        CenterRoleBadgeComponent,
    ],
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.scss",
    animations: [SLIDE_Y],
})
export class HeaderComponent {
    readonly modalService = inject(ModalService);
    readonly userStore = inject(UserStore);
    readonly notificationStore = inject(NotificationStore);

    protected readonly isNativeApp = computed(() =>
        Capacitor.isNativePlatform(),
    );

    user = this.userStore.user;
    notificationCount = toSignal(this.notificationStore.count$);

    menuItems = [
        {
            label: "마이 페이지",
            icon: "solar:user-circle-bold-duotone",
            url: "/my-page",
        },
        {
            label: "고객지원",
            icon: "solar:call-chat-rounded-bold-duotone",
            url: "/customer",
        },
    ];

    openSidemenu() {
        this.modalService.create(SideMenuComponent);
    }

    logout() {
        this.userStore.logout();
    }
}
